<template>
    <el-dialog :title="title" :visible.sync="showModal" v-if="showModal" :close-on-click-modal="false"
        :destroy-on-close="true" width="800px">
        <el-form ref="form" :rules="rules" :model="form" label-position="left" label-width="140px">
            <el-form-item label="名称" prop="name">
                <el-input v-model="form.name" placeholder="商品名称"></el-input>
            </el-form-item>
            <el-form-item label="图片(184*184倍数)" prop="cover_img">
                <upload-one v-model="form.cover_img" width="100%" height="360px"></upload-one>
            </el-form-item>
            <el-form-item label="轮播图(414*414倍数)" prop="commodity_img">
                <upload-list :list="form.commodity_img" width="100%" height="360px"></upload-list>
            </el-form-item>
            <el-form-item label="数量" prop="stock_num">
                <el-input v-model.number="form.stock_num" placeholder="商品数量"></el-input>
            </el-form-item>
            <el-form-item label="价值" prop="worth">
                <el-input v-model="form.worth" placeholder="商品价值"></el-input>
            </el-form-item>
            <el-form-item label="分类" prop="commodity_class_id" v-loading="selectLoading">
                <el-select v-model="form.commodity_class_id" filterable placeholder="选择分类">
                    <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="规格" prop="product_specifications">
                <el-tag v-for="tag in form.product_specifications" :key="tag" style="margin-right: 10px;" closable
                    :disable-transitions="false" @close="handleClose(tag)">
                    {{ tag }}
                </el-tag>
                <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small"
                    @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
                </el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加规格</el-button>
            </el-form-item>
            <el-form-item label="积分价值" prop="integral_worth">
                <el-input v-model.number="form.integral_worth" placeholder="积分数量"></el-input>
            </el-form-item>
            <el-form-item label="商家" prop="merchant_id">
                <el-select v-model="form.merchant_id" filterable placeholder="选择分类" :loading="merchantListLoading">
                    <el-option v-for="item in merchantList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="权重" prop="sort">
                <el-input-number v-model="form.sort" :min="1" :max="99" label="选择权重"></el-input-number>
            </el-form-item>
            <el-form-item label="详细介绍" prop="details">
                <tinymce :height="360" v-model="form.details" :value="form.details" ref="tinymce" />
            </el-form-item>
            <el-form-item>
                <el-button @click="trunOff">取消</el-button>
                <el-button type="primary" @click="saveData('form')" :loading="btnLoading">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import Tinymce from "@/components/Tinymce";
import UploadList from "@/components/UploadList/index.vue";
import { productList, classify } from "@/api/creditShop"

export default {
    data: () => ({
        rules: {
            name: [
                { required: true, message: '请输入商品名称', trigger: 'blur' }
            ],
            cover_img: [
                { required: true, message: '请上传商品图片', trigger: 'blur' }
            ],
            commodity_img: [
                { type: "array", required: true, message: '请上传轮播图片', trigger: 'blur' }
            ],
            stock_num: [
                { type: "number", required: true, message: '请输入商品数量', trigger: 'blur' }
            ],
            worth: [
                { required: true, message: '请输入商品价值', trigger: 'blur' },
                { pattern: /^-?\d+(,\d{3})*(\.\d{1,2})?$/, message: "请输入正确的价格" }
            ],
            commodity_class_id: [
                { required: true, message: '选择分类', trigger: 'blur' }
            ],
            product_specifications: [
                { type: "array", required: true, message: '请添加规格', trigger: 'blur' }
            ],
            integral_worth: [
                { type: "number", required: true, message: '请输入积分价值', trigger: 'blur' }
            ],
            merchant_id: [
                { required: true, message: '请选择商家', trigger: 'blur' }
            ],
            sort: [
                { type: "number", required: true, message: '请输入权重', trigger: 'blur' }
            ],
            details: [
                { required: true, message: '请输入介绍', trigger: 'blur' }
            ]
        },
        form: {
            id: null,
            name: '',
            cover_img: null,
            commodity_img: [],
            stock_num: '',
            commodity_class_id: null,
            product_specifications: [],
            worth: '',
            integral_worth: '',
            merchant_id: '',
            sort: '',
            details: ''
        },
        merchantListLoading: false,
        merchantList: [],
        inputVisible: false,
        inputValue: '',
        btnLoading: false,
        selectLoading: false,
        classList: []
    }),
    components: { UploadList, Tinymce },
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        // 模式
        type: {
            default: 'add',
            type: String
        },
        // 编辑的数据
        editData: null | Object
    },
    methods: {
        trunOff() {
            this.showModal = false
        },
        getClass() {
            this.selectLoading = true
            classify.list({ limit: 999999, state: 1 }).then(res => {
                this.classList = res.data.data
                console.log('分类列表', this.classList)
                this.selectLoading = false
            }).catch(err => { console.log('失败', err) })
        },
        handleUpdateFormModelByModalType() {
            const handlers = {
                add: () => {
                    this.form = {
                        id: null,
                        name: '',
                        cover_img: null,
                        commodity_img: [],
                        stock_num: '',
                        commodity_class_id: null,
                        product_specifications: [],
                        worth: '',
                        integral_worth: '',
                        merchant_id: '',
                        sort: '',
                        details: ''
                    }
                },
                edit: () => {
                    this.form = this.editData
                    this.form.worth *= 1
                }
            }
            console.log('触发')
            handlers[this.type]()
            this.getClass()
        },
        async initOption() {
            this.merchantListLoading = true
            const { data } = await productList.merchantList({ state: 1 })
            this.merchantList = data
            this.merchantListLoading = false
        },
        handleClose(tag) {
            this.form.product_specifications.splice(this.form.product_specifications.indexOf(tag), 1);
        },
        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.form.product_specifications.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
        },
        saveData(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    try {
                        this.btnLoading = true
                        await productList.create(this.form)
                        this.$message({
                            message: `${this.type === 'add' ? '新增' : '编辑'}商品成功!`,
                            type: 'success'
                        });
                        this.$emit('onUpdate')
                        this.trunOff()
                    } catch {
                        // this.$message.error('出错了!');
                    } finally {
                        this.btnLoading = false
                    }
                }
            });
        },
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        },
        title() {
            const { type } = this

            const title = {
                add: "新建数据",
                edit: "编辑数据"
            }

            return title[type]
        }
    },
    // watch: {
    //     show(newVal) {
    //         if (newVal) {
    //             this.handleUpdateFormModelByModalType()
    //             this.initOption()
    //         }
    //     }
    // },
    created() {
        this.handleUpdateFormModelByModalType()
        this.initOption()
    }
}
</script>

<style lang="scss" scoped>
.button-new-tag {
    // margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}

.input-new-tag {
    width: 90px;
    // margin-left: 10px;
    vertical-align: bottom;
}
</style>